import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";

export default function DenyUserMatchingConfirmationPopup() {
	const { t } = useTranslation("user-account");

	const rootStore = useRootAppStore();

	if (
		!rootStore.userAuthStore.userMatchingStore.isDenyConfirmationPopupActive
	) {
		return null;
	}

	return (
		<div id="reuse-form" className="popup" data-at="at-ReuseBetSlipModal">
			<div className="popup__card">
				<div className="popup__header">{t<string>("INFO")}</div>
				<div className="popup__body">
					{t("USER_MATCHING.DENY_INFO")}
				</div>
				<div className="popup__footer">
					<button
						type="button"
						id="close"
						onClick={() =>
							rootStore.userAuthStore.userMatchingStore.deactivateDenyConfirmationPopup()
						}
						className="popup__btn popup__btn--secondary btn btn--base btn--primary--inverted"
						data-at="at-ReuseBetSlipModal__btn--secondary"
					>
						{t<string>("COMMON.CANCEL")}
					</button>
					<button
						type="submit"
						onClick={async () => {
							await rootStore.userAuthStore.userMatchingStore.denyUserMatching();
						}}
						className="popup__btn popup__btn--primary btn btn--block btn--base btn--primary--inverted u-color--sent--danger"
						data-at="at-ReuseBetSlipModal__btn--primary"
					>
						{t("USER_MATCHING.DENY_MATCH")}
					</button>
				</div>
			</div>
		</div>
	);
}
